import request from '@/utils/request'
import setting from '@/settings'
import qs from 'qs'
const apiUrl = setting.apiUrl

export const getUsers = (params: any) =>
  request({
    url: '/users',
    method: 'get',
    data: qs.stringify(params)
  })

export const getUserInfo = (data: any) =>
  request({
    url: '/users/info',
    method: 'post',
    data: qs.stringify(data)
  })

export const getUserByName = (username: string) =>
  request({
    url: `/users/${username}`,
    method: 'get',
    data: qs.stringify(username)
  })

export const updateUser = (username: string, data: any) =>
  request({
    url: `/users/${username}`,
    method: 'put',
    data: qs.stringify(data)
  })

export const deleteUser = (username: string) =>
  request({
    url: `/users/${username}`,
    method: 'delete'
  })

export const login = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/login/loginBackstage`,
    method: 'post',
    data: qs.stringify(data)
  })

export const loginPhone = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/login/loginBackByPhone`,
    method: 'post',
    data: qs.stringify(data)
  })

export const loginOut = () =>
  request({
    url: `${apiUrl.api}/lb/login/loginOut`,
    method: 'post'
  })

export const register = (data: any) =>
  request({
    url: '/users/register',
    method: 'post',
    data: qs.stringify(data)
  })
